import { createRouter, createWebHistory } from '@ionic/vue-router';
import { Capacitor } from '@capacitor/core';
import { RouteRecordRaw } from 'vue-router';
import Account from '../views/account/Account.vue';
import BadConnection from '../views/badconnection/BadConnection.vue';
import ChangePassword from '../views/change-password/ChangePassword.vue';
import Login from '../views/login/Login.vue';
import PlayListView from '../views/playlist/PlayListView.vue';
import PlaylistList from '../views/playlist/PlaylistList.vue';
import Programs from '../views/programs/Programs.vue';
import ReleasePage from '../views/release-page/ReleasePage.vue';
import ReleaseGuide from '../views/release/ReleaseGuide.vue';
import ReleaseMain from '../views/release/ReleaseMain.vue';
import ReleaseMusic from '../views/release/ReleaseMusic.vue';
import ReleaseVideo from '../views/release/ReleaseVideo.vue';
import ResetPassword from '../views/reset-password/ResetPassword.vue';
import Settings from '../views/settings/Settings.vue';
import SignUp from '../views/signup/SignUp.vue';
import AdminAppSections from '../views/admin/AdminAppSections.vue';
import AdminEducationSections from '../views/admin/AdminEducationSections.vue';
import AdminRoles from '../views/admin/AdminRoles.vue';
import AdminMediaUpload from '../views/admin/AdminMediaUpload.vue';
import AdminReleases from '../views/admin/AdminReleases.vue';
import AdminLibraryMusic from '../views/admin/AdminLibraryMusic.vue';
import MusicLibrary from '../views/music-library/MusicLibrary.vue';
import MusicLibraryFolder from '../views/music-library/MusicLibraryFolder.vue';
import AdminTests from '../views/admin/AdminTests.vue';
import Skills from '../views/skills/Skills.vue';
import Testing from '../views/testing/Testing.vue';
import Users from '../views/users/Users.vue';
import PrivacyPolicy from '../views/privacy/PrivacyPolicy.vue';
import AccountDeletion from '../views/privacy/AccountDeletion.vue';
import OfferSupplement from '../views/privacy/OfferSupplement.vue';
import EventsList from '../views/events/EventsList.vue';
import EventDetail from '../views/events/EventDetail.vue';
import EventPaymentSuccess from '../views/events/EventPaymentSuccess.vue';
import AdminEventsList from '../views/events/AdminEventsList.vue';
import AdminEventEdit from '../views/events/AdminEventEdit.vue';
import AdminEventRegistrations from '../views/events/AdminEventRegistrations.vue';
import UsefulLinks from '../views/useful-links/UsefulLinks.vue';
import AdminUsefulLinks from '../views/useful-links/AdminUsefulLinks.vue';
import ShowcaseHome from '../views/showcase/ShowcaseHome.vue';
import SubscriptionDetail from '../views/subscriptions/SubscriptionDetail.vue';
import AdminSubscriptionsList from '../views/subscriptions/AdminSubscriptionsList.vue';
import AdminSubscriptionEdit from '../views/subscriptions/AdminSubscriptionEdit.vue';
import AdminPromoCodesList from '../views/subscriptions/AdminPromoCodesList.vue';
import AdminPromoCodeEdit from '../views/subscriptions/AdminPromoCodeEdit.vue';
import MySubscriptions from '../views/subscriptions/MySubscriptions.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    redirect: () => (Capacitor.isNativePlatform() ? '/login' : '/showcase')
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/showcase',
    name: 'Showcase',
    component: ShowcaseHome
  },
  {
    path: '/today',
    redirect: '/showcase'
  },
  {
    path: '/account',
    name: 'Account',
    component: Account
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings
  },
  {
    path: '/users',
    name: 'Users',
    component: Users
  },
  {
    path: '/admin-roles',
    name: 'AdminRoles',
    component: AdminRoles
  },
  {
    path: '/admin-app-sections',
    name: 'AdminAppSections',
    component: AdminAppSections
  },
  {
    path: '/admin-education-sections',
    name: 'AdminEducationSections',
    component: AdminEducationSections
  },
  {
    path: '/admin-media-upload',
    name: 'AdminMediaUpload',
    component: AdminMediaUpload
  },
  {
    path: '/admin-releases',
    name: 'AdminReleases',
    component: AdminReleases
  },
  {
    path: '/admin-library-music',
    name: 'AdminLibraryMusic',
    component: AdminLibraryMusic
  },
  {
    path: '/music-library',
    name: 'MusicLibrary',
    component: MusicLibrary
  },
  {
    path: '/music-library/:folderId',
    name: 'MusicLibraryFolder',
    component: MusicLibraryFolder
  },
  {
    path: '/admin-testing',
    name: 'AdminTesting',
    component: AdminTests
  },
  {
    path: '/admin-video-upload',
    redirect: '/admin-media-upload'
  },
  {
    path: '/change-password',
    name: 'ChangePassword',
    component: ChangePassword
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword
  },
  {
    path: '/signup',
    name: 'SignUp',
    component: SignUp
  },
  {
    path: '/badconnection',
    name: 'BadConnection',
    component: BadConnection
  },
  {
    path: '/programs/:shortName',
    name: 'ProgramReleases',
    component: () => import('../views/programs/ProgramReleases.vue'),
  },
  {
    path: '/programs',
    name: 'Programs',
    component: Programs
  },
  {
    path: '/release-page',
    name: 'ReleasePage',
    component: ReleasePage
  },
  {
    path: '/ReleaseMain',
    name: 'ReleaseMain',
    component: ReleaseMain,
    children: [
      {
        path: '/guide',
        name: 'ReleaseGuide',
        component: ReleaseGuide,
      },
      {
        path: '/video',
        name: 'ReleaseVideo',
        component: ReleaseVideo,
      },
      {
        path: '/music',
        name: 'ReleaseMusic',
        component: ReleaseMusic,
      },
    ],
  },
  {
    path: '/playlist-list',
    name: 'PlaylistList',
    component: PlaylistList
  },
  {
    path: '/playlist-view',
    name: 'PlayListView',
    component: PlayListView
  },
  {
    path: '/skills',
    name: 'Skills',
    component: Skills,
    props: { mediaCategory: 'TRAININGS', pageTitle: 'Тренинги' }
  },
  {
    path: '/exercises',
    name: 'Exercises',
    component: Skills,
    props: { mediaCategory: 'EXERCISES', pageTitle: 'Упражнения' }
  },
  {
    path: '/workouts',
    name: 'Workouts',
    component: Skills,
    props: { mediaCategory: 'WORKOUTS', pageTitle: 'Тренировки' }
  },
  {
    path: '/education',
    name: 'Education',
    component: Skills,
    props: { mediaCategory: 'EDUCATION', pageTitle: 'Образование' }
  },
  {
    path: '/testing',
    name: 'Testing',
    component: Testing
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  },
  {
    path: '/account-deletion',
    name: 'AccountDeletion',
    component: AccountDeletion
  },
  {
    path: '/offer-supplement',
    name: 'OfferSupplement',
    component: OfferSupplement
  },
  {
    path: '/events',
    name: 'EventsList',
    component: EventsList
  },
  {
    path: '/useful-links',
    name: 'UsefulLinks',
    component: UsefulLinks
  },
  {
    path: '/admin-useful-links',
    name: 'AdminUsefulLinks',
    component: AdminUsefulLinks
  },
  {
    path: '/events/success',
    name: 'EventPaymentSuccess',
    component: EventPaymentSuccess
  },
  {
    path: '/events/:id',
    name: 'EventDetail',
    component: EventDetail
  },
  {
    path: '/admin-events',
    name: 'AdminEventsList',
    component: AdminEventsList
  },
  {
    path: '/admin-events/new',
    name: 'AdminEventNew',
    component: AdminEventEdit
  },
  {
    path: '/admin-events/:id/edit',
    name: 'AdminEventEdit',
    component: AdminEventEdit
  },
  {
    path: '/admin-events/:id/registrations',
    name: 'AdminEventRegistrations',
    component: AdminEventRegistrations
  },
  {
    path: '/admin-payments',
    name: 'AdminPayments',
    component: () => import('../views/admin/AdminPayments.vue')
  },
  {
    path: '/admin-returns',
    name: 'AdminReturns',
    component: () => import('../views/admin/AdminReturns.vue')
  },
  {
    path: '/admin-subscriptions',
    name: 'AdminSubscriptionsList',
    component: AdminSubscriptionsList
  },
  {
    path: '/admin-subscriptions/new',
    name: 'AdminSubscriptionNew',
    component: AdminSubscriptionEdit
  },
  {
    path: '/admin-subscriptions/:id/edit',
    name: 'AdminSubscriptionEdit',
    component: AdminSubscriptionEdit
  },
  {
    path: '/admin-promo-codes',
    name: 'AdminPromoCodesList',
    component: AdminPromoCodesList
  },
  {
    path: '/admin-promo-codes/new',
    name: 'AdminPromoCodeNew',
    component: AdminPromoCodeEdit
  },
  {
    path: '/admin-promo-codes/:id/edit',
    name: 'AdminPromoCodeEdit',
    component: AdminPromoCodeEdit
  },
  {
    path: '/subscriptions/:id',
    name: 'SubscriptionDetail',
    component: SubscriptionDetail
  },
  {
    path: '/my-subscriptions',
    name: 'MySubscriptions',
    component: MySubscriptions
  },
  {
    path: '/my-tickets',
    name: 'MyTickets',
    component: () => import('../views/events/MyTickets.vue')
  },
  {
    path: '/messenger',
    name: 'MessengerInbox',
    component: () => import('../views/messenger/MessengerInbox.vue')
  },
  {
    path: '/messenger/invite/:token',
    name: 'MessengerInviteJoin',
    component: () => import('../views/messenger/MessengerInviteJoin.vue')
  },
  {
    path: '/messenger/chat/:id',
    name: 'MessengerChat',
    component: () => import('../views/messenger/MessengerChat.vue')
  },
  {
    path: '/messenger/chat/:id/info',
    name: 'MessengerChatInfo',
    component: () => import('../views/messenger/MessengerChatInfo.vue')
  },
  {
    path: '/messenger/new',
    name: 'MessengerNewDirect',
    component: () => import('../views/messenger/MessengerNewDirect.vue')
  },
  {
    path: '/messenger/requests',
    name: 'MessengerDmRequests',
    component: () => import('../views/messenger/MessengerDmRequests.vue')
  },
  {
    path: '/messenger/publics',
    name: 'MessengerPublicCatalog',
    component: () => import('../views/messenger/MessengerPublicCatalog.vue')
  },
  {
    path: '/messenger/publics/new',
    name: 'MessengerCreatePublic',
    component: () => import('../views/messenger/MessengerCreatePublic.vue')
  },
  {
    path: '/messenger/groups/new',
    redirect: { name: 'MessengerCreatePublic' }
  },
  {
    path: '/messenger/privacy',
    name: 'MessengerPrivacySettings',
    component: () => import('../views/messenger/MessengerPrivacySettings.vue')
  },
  {
    path: '/admin/messenger/support',
    redirect: { name: 'MessengerInbox', query: { segment: 'support' } },
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
